import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import { Dropdown, Menu, Label } from 'semantic-ui-react'
import styles from './styles.scss'
const cx = classnames.bind(styles)

const DropdownMenuLinks = ({ text, options = [], elmId }) => (
  <Menu compact fluid className={cx('dropdown-menu')}>
    {/**
     * "Why a hidden label?", you ask... ARIA compliance. Associated via aria-labelledby below.
     **/}
    <Label style={{ display: 'none' }} id={`${elmId}_menu`}>
      {text}
    </Label>
    <Dropdown
      data-elm-id={`${elmId}_dropdown`}
      aria-labelledby={`${elmId}_menu`}
      scrolling
      fluid
      text={text}
      className={cx('link', 'item')}
    >
      <Dropdown.Menu>
        {/**
         * Normally we'd use Dropdown.Item here, however in this case it causes ARIA issues because we need aria-selected
         * to come through but Dropdown.Item won't do that in this case - so we'll must use an <a> tag with the same class.
         **/}
        {options.map((item, index) => (
          <a
            className='item'
            key={index}
            href={item.href}
            data-elm-id={`${elmId}_links_${index + 1}`}
            role='option'
          >
            {item.text}
          </a>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  </Menu>
)

DropdownMenuLinks.propTypes = {
  text: PropTypes.string.isRequired,
  options: PropTypes.array,
  elmId: PropTypes.string.isRequired,
}

DropdownMenuLinks.propTypes = {
  text: PropTypes.string.isRequired,
}

export default DropdownMenuLinks
